/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import styled from 'styled-components'
/* ------------------------- Internal Dependencies -------------------------- */
import ListItemIcon from 'molecules/ListItemIcon'
/* ------------------------------- Component -------------------------------- */
const SpotlightSwitches = (props) => {
  const { renderTree, focusChange } = props
  const Component = renderTree && renderTree.type || null
  return (
    <div>
      { !renderTree ? null : renderTree.items.map( (item)=> <Component onMouseOver={()=> focusChange(item.spotlight, item.id) } {...item} /> )}
    </div>
  )
}

/* ---------------------------- Export Package ------------------------------ */
export default SpotlightSwitches


// WEBPACK FOOTER //
// ./src/interface/containers/spotlight/SpotlightSwitches/render/index.js